import { render, staticRenderFns } from "./mcrFooter.vue?vue&type=template&id=b2919dd4&scoped=true"
import script from "./mcrFooter.vue?vue&type=script&lang=js"
export * from "./mcrFooter.vue?vue&type=script&lang=js"
import style0 from "./mcrFooter.vue?vue&type=style&index=0&id=b2919dd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2919dd4",
  null
  
)

export default component.exports